import { render, staticRenderFns } from "./ContactTypeSelect.vue?vue&type=template&id=45b394b2&"
import script from "./ContactTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ContactTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports